import React from 'react';
import PropTypes from 'prop-types';
import Message from 'Components/Modal/Message';

const SaveCouponSuccess = props => {
  const buttonConfig = {
    primary: {
      label: 'BÜLTENE GİT',
      onClick: props.onPrimaryButtonClick
    },
    secondary: {
      label: 'KUPONLARIM',
      onClick: props.onSecondaryButtonClick
    }
  };

  return (
    <Message type='success' buttonConfig={ buttonConfig }>
      <p>Tebrikler kuponun başarıyla kaydedildi. Kuponlarına istediğin zaman <strong>“Kuponlarım”</strong> adımından ulaşabilirsin.</p>
    </Message>
  );
};

SaveCouponSuccess.propTypes = {
  onPrimaryButtonClick: PropTypes.func.isRequired,
  onSecondaryButtonClick: PropTypes.func.isRequired
};

export default SaveCouponSuccess;
